import type {EditableFieldType} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class EditableFieldTypeDataService {

    public static readonly serviceName = 'editableFieldTypeDataService';
    private static readonly ROUTE = 'editable-field-types';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async queryByRecordEditation(recordEditationId: string): Promise<EditableFieldType[]> {
        return this.ajaxService
            .createRequest(`${EditableFieldTypeDataService.ROUTE}`)
            .get({recordEditation: recordEditationId});
    }
}